import { InputEvent, useState } from 'react';

import { Grid } from '@mui/material';

import { StoreAutoComplete } from 'components/autocompletes';
import { CissTextField } from 'components/fields';
import { Filter } from 'components/filter';
import { useApplicationContext } from 'context/ApplicationContext';
import { FilterValuesProps } from 'hooks/useFilter';

export function RevendedorGridFilter() {
    const { user } = useApplicationContext();
    const requiredStore = !['MASTER', 'SUPORTE_CISS'].includes(user.tipoUsuario.tipoUsuarioEnum);

    const [filterLoja, setFilterLoja] = useState<FilterValuesProps>({
        idProperty: 'cdLoja',
        property: 'cdLoja',
        operator: 'eq',
        value: null,
        required: requiredStore ? 'Loja é obrigatória' : '',
    });

    const [filterDocumento, setFilterDocumento] = useState<FilterValuesProps>({
        property: 'dsDocumento',
        operator: 'eq',
        value: null,
    });

    /**
     * Formata o input para permitir apenas números.
     */
    const onInputChangeDocumento = (e: InputEvent<HTMLDivElement>) => {
        const input = e.target as HTMLInputElement;
        input.value = input.value.replace(/\D/g, '');
    };

    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterDocumento, setter: setFilterDocumento },
                { value: filterLoja, setter: setFilterLoja },
            ]}
        >
            <Grid sx={{ flex: 4 }}>
                <StoreAutoComplete
                    value={filterLoja.value}
                    onChange={(e, value) => setFilterLoja((oldState: FilterValuesProps) => ({ ...oldState, value }))}
                />
            </Grid>
            <Grid sx={{ flex: 4 }}>
                <CissTextField
                    label="Documento"
                    value={filterDocumento.value}
                    onInput={onInputChangeDocumento}
                    onChange={(e) => setFilterDocumento((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
        </Filter>
    );
}
